import React from 'react'
import { components } from 'react-select'
import ExpiryDisplay from './ExpiryDisplay'

const ExpiryValue = ({
  children,
  ...props
}: React.ComponentProps<typeof components.ValueContainer>) => {
  const { ValueContainer } = components
  if (!props.hasValue) {
    return <ValueContainer {...props}>{children}</ValueContainer>
  }

  return (
    <ValueContainer {...props}>
      <ExpiryDisplay isValue={true}>{children}</ExpiryDisplay>
    </ValueContainer>
  )
}

export default ExpiryValue
